'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalWrapper = function ModalWrapper(props) {
    var className = props.className,
        children = props.children;

    var wrapperProps = Object.assign({}, props, { className: (0, _classnames2.default)('luna-modal__wrapper', [className]) });
    return _react2.default.createElement("div", Object.assign({}, wrapperProps), children);
};
ModalWrapper.propTypes = {
    className: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node.isRequired
};
exports.default = ModalWrapper;
//# sourceMappingURL=ModalWrapper.js.map